import React, { FC } from 'react'
import { RichTextWrapper } from '../../../../styles/global'
import { renderRichText } from '../../../../utils/richTextHandler.utils'
import Typography from '../../typography'

type Props = {
  data: any
}

export const Agenda: FC<Props> = ({ data }) => {
  const title = data.title?.title || data.title || ''

  return (
    <div className="Agenda__Item">
      {data.label && (
        <Typography type="captionAlt" className="Agenda__Item-Label">
          {data.label}
        </Typography>
      )}

      {title && (
        <Typography type="header6" className="Agenda__Item-Title">
          {title}
        </Typography>
      )}

      {data.body && (
        <div className="Agenda__Item-Body">
          <RichTextWrapper $type="body" className="font__inter">
            {renderRichText(data.body)}
          </RichTextWrapper>
        </div>
      )}
    </div>
  )
}
